import React from "react";
import { Controller } from "react-hook-form";
import NewCustomFileInput from "../../../components/common/NewCustomFileInput";
import Input from "../../../components/Input";

type Props = {
  register?: any;
  control?: any;
  errors?: Record<string, any>;
  clearErrors?: any;
  isPending?: boolean;
  payload: any;
};

const FillInformationForm: React.FC<Props> = ({
  register,
  clearErrors,
  errors = {},
  control,
  isPending,
  payload,
}) => {
  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <p className="text-sm text-[#1E293B] flex items-center gap-1">
      <span className="font-medium text-[#212121]">{label}:</span> {value}
    </p>
  );

  return (
    <div className="w-[1280px] mx-auto text-[#1E293B] space-y-4 py-4">
      <div className="flex justify-center items-center">
        <p className="text-2xl text-[#212121] tracking-[-0.5px]">
          Fill Information
        </p>
      </div>

      <div className="border border-[#d2d2d2] rounded-[20px] p-6 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
        {/* Request Details */}
        <div className="space-y-3 border p-2 border-[#d2d2d2] rounded-[10px]">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Request Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-4">
            <TwoCol label="Origin" value={payload?.originWarehouseId} />
            <TwoCol
              label="Destination"
              value={payload?.destinationWarehouseId}
            />
            <TwoCol label="Capacity" value={payload?.weightCapacity} />
            <TwoCol label="On Date" value={payload?.onDate} />
            <TwoCol label="Cutoff Time" value={payload?.cutOffTime} />
          </div>
        </div>

        {/* Driver Details */}
        <div className="space-y-3 p-2">
          <Input
            title="Company Name"
            className="col-span-4"
            type="text"
            name="companyName"
            register={register}
            error={errors?.companyName}
            validation={{ required: "Company Name is required" }}
          />
          <h3 className="text-[#212121]/70 font-medium text-base">
            Driver Details
          </h3>
          <div className="grid grid-cols-4 gap-4">
            <Input
              className="col-span-2"
              name="driverName"
              placeholder="Enter Name"
              title="Driver Name"
              register={register}
              error={errors?.driverName}
              validation={{ required: "Driver Name is required" }}
            />
            <Input
              className="col-span-2"
              name="driverMobile"
              placeholder="Enter Number"
              title="Mobile Number"
              type="text"
              register={register}
              error={errors?.driverMobile}
              validation={{ required: "Mobile Number is required" }}
            />

            {/* License Upload */}
            <div className="col-span-2">
              <label className="text-[#1E293B] text-sm">Upload License</label>
              <Controller
                control={control}
                name="driverLicenseDoc"
                rules={{ required: "File is required" }}
                render={({ field, fieldState }) => (
                  <NewCustomFileInput
                    initialFile={field.value}
                    onFileSelect={(file) => {
                      field.onChange(file);
                      clearErrors("driverLicenseDoc");
                    }}
                    error={fieldState.error}
                  />
                )}
              />
            </div>

            {/* Iqama Upload */}
            <div className="col-span-2">
              <label className="text-[#1E293B] text-sm">Upload Iqama</label>
              <Controller
                control={control}
                name="driverIqmaDoc"
                rules={{ required: "File is required" }}
                render={({ field, fieldState }) => (
                  <NewCustomFileInput
                    initialFile={field.value}
                    onFileSelect={(file) => {
                      field.onChange(file);
                      clearErrors("driverIqmaDoc");
                    }}
                    error={fieldState.error}
                  />
                )}
              />
            </div>
          </div>
        </div>

        {/* Vehicle Details */}
        <div className="space-y-3 p-2">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Vehicle Details
          </h3>
          <div className="grid grid-cols-4 gap-4">
            <Input
              className="col-span-2"
              name="vehicleNumber"
              placeholder="Enter Number"
              title="Vehicle Number"
              type="text"
              register={register}
              error={errors?.vehicleNumber}
              validation={{ required: "Vehicle Number is required" }}
            />
            <div className="col-span-2">
              <label className="text-[#1E293B] text-sm">Vehicle Doc</label>
              <Controller
                control={control}
                name="vehicleDoc"
                rules={{ required: "File is required" }}
                render={({ field, fieldState }) => (
                  <NewCustomFileInput
                    initialFile={field.value}
                    onFileSelect={(file) => {
                      field.onChange(file);
                      clearErrors("vehicleDoc");
                    }}
                    error={fieldState.error}
                  />
                )}
              />
            </div>
          </div>
        </div>

        {/* Quotation Details */}
        <div className="space-y-3 p-2">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Quotation Details
          </h3>
          <div className="grid grid-cols-4 gap-4">
            <Input
              className="col-span-1"
              name="amount"
              placeholder="230 SAR"
              title="Enter Amount"
              type="number"
              register={register}
              error={errors?.amount}
              validation={{ required: "Amount is required" }}
            />
            <Input
              className="col-span-3"
              name="note"
              placeholder="Write Note.."
              title="Enter Note"
              register={register}
              error={errors?.note}
              validation={{ required: "Note is required" }}
            />
          </div>
        </div>

        {/* Submit */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={isPending}
            className="px-4 py-2 bg-[#FFD74F] text-sm font-medium rounded-full"
          >
            Submit Form
          </button>
        </div>
      </div>
    </div>
  );
};

export default FillInformationForm;
